import { isSupportedEvent } from "../../events.js";
import { createLegacyPayload } from "./legacy-payload.js";
import { Pixel } from "@source-digital/pixel";
import { loadUtmParams } from "./utm.js";
var define_import_meta_env_default = { BASE_URL: "/", MODE: "production", DEV: false, PROD: true, SSR: false };
const beaconURL = define_import_meta_env_default.SOURCE_PIXEL_URL ?? "https://pixel.sourcesync.io/1.0/pixel.gif";
async function createSendPixel(config) {
  const logger = config.logger ?? (() => {
  });
  if (config.sendPixel != null)
    return config.sendPixel;
  if (config.pixel != null) {
    const pixel = new Pixel({
      beaconURL,
      ...config.pixel
    });
    pixel.init();
    return (body) => {
      pixel.send(body).catch(logger);
    };
  }
  if (config.waitForPromise != null) {
    const { pixel: pixelConfig } = await config.waitForPromise;
    const pixel = new Pixel({
      beaconURL,
      ...pixelConfig
    });
    return (body) => {
      pixel.send(body).catch(config.logger);
    };
  }
  logger == null ? void 0 : logger("WARN: No pixel config found. No data will be sent.");
  return () => {
  };
}
function sourcePixelPlugin(config) {
  let sendPixel = null;
  const queue = [];
  const utmParams = loadUtmParams();
  createSendPixel(config).then((fn) => {
    sendPixel = fn;
    while (queue.length > 0) {
      track(queue.shift());
    }
  }).catch(config.logger);
  function track(data) {
    var _a, _b, _c;
    if (!config.enabled)
      return;
    const { event: eventName, properties: payload } = data.payload;
    if (!isSupportedEvent(eventName)) {
      (_a = config.logger) == null ? void 0 : _a.call(config, "WARN: Not supported.", eventName, payload);
      return;
    }
    if (sendPixel == null) {
      queue.push(data);
      (_b = config.logger) == null ? void 0 : _b.call(
        config,
        `event:queued:[${eventName}]`,
        payload
      );
      return;
    }
    const body = createLegacyPayload(eventName, payload, utmParams, config.getAdditionalData());
    (_c = config.logger) == null ? void 0 : _c.call(
      config,
      `event:sent:[${eventName}]`,
      body
    );
    sendPixel(body);
  }
  const loaded = true;
  return {
    name: "source",
    initialize: ({ config: config2 }) => {
      var _a;
      (_a = config2.logger) == null ? void 0 : _a.call(config2, "source pixel analytics enabled");
    },
    config,
    page: ({ payload }) => {
    },
    track,
    identify: ({ payload }) => {
    },
    loaded: () => {
      return loaded;
    }
  };
}
export {
  sourcePixelPlugin
};
